import type { NavbarMainItem } from "@/components/navigation/navigation.types";
import { Routes } from "@/utils/routes";

export const ADMIN_NAVBAR_ITEM: NavbarMainItem<Record<string, string>> = {
  admin: true,
  href: (proj: string, env: string) => Routes.project.environment.admin(proj, env),
  text: "Admin links",
  id: "admin-link",
  icon: "lock",
  iconClassName: "h-[14px] w-[14px]",
  subpages: [
    {
      href: (proj: string, env: string) => Routes.project.environment.queryPlans(proj, env),
      text: "Plans",
      id: "plans",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) => Routes.project.environment.traces(proj, env),
      text: "Traces",
      id: "traces",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) => Routes.project.environment.jobs(proj, env),
      text: "Jobs",
      id: "plans",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) => Routes.project.environment.metadataCronJobs(proj, env),
      text: "Metadata cron jobs",
      id: "metadata-cron-jobs",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) =>
        Routes.project.environment.workflowOrchestrator(proj, env),
      text: "Workflow orchestrator",
      id: "workflow-orchestrator",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) => Routes.project.environment.graphViz(proj, env),
      text: "Graph viz (WIP)",
      id: "graph-viz",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: () => Routes.cloudClusters,
      text: "Cloud Clusters (global)",
      id: "cloud-clusters",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: () => Routes.cloudAccounts,
      text: "Cloud Accounts (global)",
      id: "cloud-clusters",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) => Routes.project.environment.adminNodes(proj, env),
      text: "Node history",
      id: "admin-nodes",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
    {
      href: (proj: string, env: string) => Routes.project.environment.adminBaseImages(proj, env),
      text: "Engine base images",
      id: "admin-base-images",
      icon: "lock",
      iconClassName: "h-[14px] w-[14px]",
    },
  ],
};
